var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"cursor":"pointer","width":"100%!important","height":"100%!important"},on:{"click":function($event){return _vm.Clipboard($event)}}},[_c('em',{staticClass:"bi bi-copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }